module.exports = __webpack_public_path__ + "static/media/BR.cdc2f2cc.png";